import { useEffect, useState } from 'react';

/**
 * Devuelve `true` si el media query matchea. Para alternar layouts según el
 * ancho de pantalla (ej. tabla en desktop / tarjetas en mobile).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
